import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19h1.341a7 7 0 0 0 6.845 -5.533l.628 -2.934a7 7 0 0 1 6.846 -5.533h1.34","key":"svg-0"}]]

/**
 * IconStrokeCurved
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3Ryb2tlLWN1cnZlZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCAxOWgxLjM0MWE3IDcgMCAwIDAgNi44NDUgLTUuNTMzbC42MjggLTIuOTM0YTcgNyAwIDAgMSA2Ljg0NiAtNS41MzNoMS4zNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/stroke-curved
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStrokeCurved = createReactComponent('outline', 'stroke-curved', 'StrokeCurved', __iconNode);

export default IconStrokeCurved;